export default "__VITE_ASSET__BeaFFzzI__"